<h1 mat-dialog-title>Add address</h1>
<mat-dialog-content class="mat-typography">
  <app-location-form [form]="locationForm"></app-location-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button cdkFocusInitial [disabled]="!locationForm.valid" (click)="addLocation()">Add</button>
</mat-dialog-actions>
